import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { InvoiceService } from '../_services/invoice.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { ActivatedRoute, Router } from '@angular/router'; 
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  baseUrl = environment.baseUrl;
  contactUUID: string = "";
  searchInfo: string = "";
  invoiceInfo: any;
  isSearch: boolean = false;
  p: number = 0;
  limits: number = 10;
  total: number = 0;
  no_results_message: string = "";
  filter: string = "all";
  loading_msg = 'Chargement en cours ';
  diplay_loading = this.loading_msg;

  searchInvoiceForm: FormGroup = new FormGroup({
    search_invoice: new FormControl("")
  })

  constructor(
    private http: HttpClient,
    private invoice: InvoiceService,
    private tokenStorage: TokenStorageService,
    private activatedRoute: ActivatedRoute,
  ) { }


    ngOnInit(): void {
      this.contactUUID = this.tokenStorage.getToken() || "";
      this.getInvoices();

    }
  
    getInvoices(): void {
      this.isSearch = false;
      
      this.diplay_loading = this.loading_msg;

      if(this.filter == 'all'){
        this.invoice.getInvoices$(this.contactUUID, this.p).subscribe((data) => {
          this.diplay_loading = '';
          this.invoiceInfo = data.records;
          this.total = data.count;
        })
      }else if(this.filter == 'rec'){
        this.invoice.getInvoicesReceivable$(this.contactUUID, this.p).subscribe((data) => {
          this.diplay_loading = '';
          this.invoiceInfo = data.records;
          this.total = data.count;
        })
      }
    }

    changeInvoiceFilter(btnFilter:string){
      console.log("function called", btnFilter);
      this.filter = btnFilter;
      this.getInvoices();
      //window.open('../myURL/mypage.jsp?rurl=' + encodeURIComponent($('display').attr('href')));
    }

    pageChangeEvent(event: number){
      this.p = event - 1;
  
      if (this.isSearch) {
        this.searchInvoice(this.searchInfo);
      }
      else {
        this.getInvoices();
      }
    }
  
    onSubmit(values: any): void {
      this.p = 0;
      this.searchInfo = values.search_invoice;
      this.searchInvoice(this.searchInfo);
    }
  
    searchInvoice(search: string): void {
      this.isSearch = true;
      this.filter = 'all';
  
      this.invoice.searchInvoice$(this.contactUUID, search, this.p).subscribe({
        next: (data: any) => {
          this.invoiceInfo = data.records;
          this.total = data.count;
          if(this.total == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
        },
        error: (err: any) => {
          console.log("Something went wrong searching invoices: ", err.statusText)
        }
      });
    }

    invoicePrint(invoice: number, name: string): void {

      this.http.post(this.baseUrl + `/invoices/` + invoice + `/export/pdf?uuid=` + this.contactUUID, invoice, { responseType: 'blob'}).subscribe(res =>{
        let blob = new Blob([res], { type: 'application/pdf' });
        let pdfUrl = window.URL.createObjectURL(blob);

        let popupWin: any;
        popupWin = window.open(pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');

        setTimeout(function() {
          popupWin.window.print();
        }, 250);

      });

    }

  }


  

